"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var react_apollo_1 = require("react-apollo");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var season_card_1 = require("../../components/season/season-card");
var GqlSeasons = require("../../core/gql/queries/seasons");
var season_1 = require("../../models/season");
var SeasonList = function (_a) {
    var selectSeasonIdCallback = _a.selectSeasonIdCallback, program = _a.program;
    var querySeasons = react_apollo_1.useQuery(GqlSeasons.QUERY, { variables: { programId: program.id } });
    if (querySeasons.loading)
        return (React.createElement(teamsnap_ui_1.PanelRow, { mods: "u-textCenter" },
            React.createElement("div", { className: "Loader-indicator" },
                React.createElement("span", { className: "SpinAnimation" }),
                React.createElement("div", { className: "Loader-indicatorText" }, "Loading seasons..."))));
    if (querySeasons.error)
        return React.createElement("div", null, querySeasons.error);
    if (querySeasons.data.seasons.length > 0) {
        return React.createElement(React.Fragment, null,
            " ",
            lodash_1.map(lodash_1.sortBy(querySeasons.data.seasons, ["name"]), function (season) {
                return React.createElement(season_card_1.default, { key: season.id, season: season, program: program, selectSeasonIdCallback: selectSeasonIdCallback });
            }),
            " ");
    }
    else {
        return (React.createElement(teamsnap_ui_1.PanelRow, { mods: "u-textCenter" },
            React.createElement("h4", null,
                "No seasons for this program currently exist.\u00A0\u00A0",
                React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: "plus", iconPosition: "left", onClick: function () { return selectSeasonIdCallback(season_1.ActivitySeasonType.ClubSeason, null); } }, "Create Season"))));
    }
};
exports.default = SeasonList;
//# sourceMappingURL=season-list.js.map